import "../styles/about.css";

import firstEnrollment from "../photos/firstenroll.jpeg";
import project0 from "../photos/project0.jpeg";
import project1 from "../photos/project1.jpeg";
import project2 from "../photos/project2.jpeg";
import project3 from "../photos/project3.png";
import project4 from "../photos/project4.jpeg";
import project5 from "../photos/project5.jpeg";
import person0 from "../photos/people0.jpeg";
import person1 from "../photos/people1.jpeg";
import person2 from "../photos/people2.jpeg";
import person3 from "../photos/people3.jpeg";
import person4 from "../photos/people4.jpeg";
import person5 from "../photos/people5.jpeg";
import person6 from "../photos/people6.jpeg";
import person7 from "../photos/people7.jpeg";
import person8 from "../photos/people8.jpeg";
import person9 from "../photos/people9.jpeg";
import person10 from "../photos/people10.jpeg";
import person11 from "../photos/people11.jpeg";

const traits = [
  { icon: "💻", label: "Programming Skills" },
  { icon: "🔭", label: "Vision" },
  { icon: "🎯", label: "Pursuit" },
  { icon: "🤝", label: "Connect" },
  { icon: "🏅", label: "Academic Achievements" },
  { icon: "🔥", label: "Passion" },
  { icon: "☀️", label: "Optimistic" },
  { icon: "👑", label: "Leadership" },
  { icon: "🎮", label: "Hobbies" },
  { icon: "👥", label: "Friends" },
  { icon: "🌿", label: "Leisure" },
  { icon: "🧩", label: "Problem-Solving" },
];

export default function About() {
  return (
    <div className="about-page">

      {/* ════ COLUMN 1 — Left Photos ════ */}
      <div className="about-col about-col--photos">

        {/* First Enrollment */}
        <div className="about-photo-section">
          <p className="about-photo-section__label">— First Enrollment —</p>
          <div className="about-photo-grid about-photo-grid--1">
            <img className="about-photo-img" src={firstEnrollment} alt="First enrollment" />
          </div>
        </div>

        {/* Projects */}
        <div className="about-photo-section">
          <p className="about-photo-section__label">— Projects —</p>
          <div className="about-photo-grid about-photo-grid--2">
            <img className="about-photo-img" src={project0} alt="Project 1" />
            <img className="about-photo-img" src={project1} alt="Project 2" />
            <img className="about-photo-img" src={project2} alt="Project 3" />
            <img className="about-photo-img" src={project3} alt="Project 4" />
            <img className="about-photo-img" src={project4} alt="Project 5" />
            <img className="about-photo-img" src={project5} alt="Project 6" />
          </div>
        </div>

      </div>

      {/* ════ COLUMN 2 — Narrative Text ════ */}
      <div className="about-col about-col--text">

        {/* Introduction */}
        <div className="about-text-section">
          <p className="about-text-section__label">— Introduction —</p>
          <p className="about-text-section__body">
            I am Justin, a Computer Engineering student at First Asia Institute of
            Technology and Humanities. I am passionate about coding, software development,
            software IC design, data science, and learning new technologies.
            Through the impending progress of technology, so does demand for skilled
            individuals who can navigate the complexities of the digital world. With a
            passion for problem-solving and engineering, I am driven to contribute to
            the ever-evolving canvas of technology.
          </p>
        </div>

        <div className="about-divider" />

        {/* Experience */}
        <div className="about-text-section">
          <p className="about-text-section__label">— Experience —</p>
          <p className="about-text-section__body">
            I am an academic achiever ever since primary school. And now, in college,
            I continue to excel in my studies, consistently ranking among the top students
            and entitled as one of both the Dean's and President's Listers. The road for
            problem-solving is not far in my vision. I am practiced to multiple programming
            languages, including C, Hardware Description Languages, Python, CSS, and more.
            Aside from my programming and academic skills, I also am proficient at leading
            teams, managing projects, and communicating effectively. This has led me to be
            a leader in multiple projects and organizations, where I have honed my ability
            to collaborate with others and drive results. I am also a skilled writer — I
            can make narratives, stories, and poems. All of these allowed me to be a well-
            rounded individual, capable of tackling complex problems and delivering results
            in a variety of contexts, showcasing my creativity.
          </p>
        </div>

        <div className="about-divider" />

        {/* Leisure and Friends */}
        <div className="about-text-section">
          <p className="about-text-section__label">— Leisure and Friends —</p>
          <p className="about-text-section__body">
            Outside my academic life, I do not let myself be deprived with leisure and fun.
            I have a wide variety of hobbies, including playing video games, watching movies, and
            hanging out with friends. Friends and social connections are important to me, and I value
            the time I spend with them. Most of the people who stayed with me through the years are my
            friends, and I am grateful for their support and companionship. For me, leisure is not just
            a way to relax and unwind, but also a way to connect with others.
          </p>
        </div>

        <div className="about-divider" />

        {/* Trait tags */}
        <div className="about-text-section">
          <p className="about-text-section__label">— More About Me —</p>
          <div className="about-traits">
            {traits.map((t) => (
              <div key={t.label} className="about-trait">
                <span className="about-trait__icon">{t.icon}</span>
                <span className="about-trait__label">{t.label}</span>
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* ════ COLUMN 3 — Right Photos ════ */}
      <div className="about-col about-col--photos">

        {/* Connect with People */}
        <div className="about-photo-section">
          <p className="about-photo-section__label">— Connect with People —</p>
          <div className="about-photo-grid about-photo-grid--2">
            <img className="about-photo-img" src={person0} alt="Connect with people 1" />
            <img className="about-photo-img" src={person1} alt="Connect with people 2" />
            <img className="about-photo-img" src={person2} alt="Connect with people 3" />
            <img className="about-photo-img" src={person3} alt="Connect with people 4" />
          </div>

          {/* Extra 2 photos to match column 1 length */}
          <div style={{ height: "0px" }} />

          <div className="about-photo-grid about-photo-grid--2">
            <img className="about-photo-img" src={person4} alt="Connect with people 5" />
            <img className="about-photo-img" src={person5} alt="Connect with people 6" />
            <img className="about-photo-img" src={person6} alt="Connect with people 7" />
            <img className="about-photo-img" src={person7} alt="Connect with people 8" />
          </div>
        </div>

        <div className="about-photo-section">
          <div className="about-photo-grid about-photo-grid--2">
            <img className="about-photo-img" src={person8} alt="Connect with people 9" />
            <img className="about-photo-img" src={person9} alt="Connect with people 10" />
            <img className="about-photo-img" src={person10} alt="Connect with people 11" />
            <img className="about-photo-img" src={person11} alt="Connect with people 12" />
          </div>
        </div>

      </div>

    </div>
  );
}